module.exports = __webpack_public_path__ + "static/img/EmmaMckeon.577f3f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/EmmaMckeon.jpg
// module id = D2vI
// module chunks = 0